export default {
    setKpPortalLoggedMember(state, data){
        state.kpPortalLoggedMember = data
    }
}